/*** IMPORTS FROM imports-loader ***/
var define = false;

export default {
	init: (app, gsap, Swiper, Plyr) => {
		const $body = $('body'),
			$heroHome = $('[data-hero]'),
			$heroHomeType = $heroHome.get(0).dataset.hero;

		if ($heroHome.length && $heroHomeType == 'slider') {
			const $swiperHero = $('[data-slider="hero"]');
			if ($swiperHero.length) {
				const swiperHero = new Swiper($swiperHero.get(0), {
					init: false,
					loop: false,
					pagination: { el: '.swiper-pagination', clickable: true },
					navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
					on: {
						init: (e) => {
							const currentSlide = e.slides[e.activeIndex];
							$(currentSlide).find('.hero-title').removeAttr('style');
						},
					},
				});

				swiperHero.on('beforeTransitionStart', (e) => {
					const previousSlide = e.slides[e.previousIndex];
					gsap.to($(previousSlide).find('> .item-line-hero'), { y: 20, autoAlpha: 0, duration: 0.3, ease: 'power1.inOut', stagger: 0.1 });
				});

				swiperHero.on('slideChangeTransitionEnd', (e) => {
					const currentSlide = e.slides[e.activeIndex];
					gsap.to($(currentSlide).find('> .item-line-hero'), { y: 0, autoAlpha: 1, duration: 0.3, ease: 'power1.inOut', stagger: 0.1 });
				});

				$body.on('dom:ready', () => setTimeout(() => swiperHero.init(), 1000));
			}
		}

		if ($heroHomeType == 'video') {
			const $playerHero = $('#hero-video');
			if ($playerHero.length) {
				const playerHero = new Plyr($playerHero.get(0));
				playerHero.muted = true;
				playerHero.play();
			}
		}

		const videoBtns = document.querySelectorAll('.video-btn');
		if (videoBtns.length) {
			videoBtns.forEach(btn => {
				const target = btn.dataset.videoTarget;
				$(target).iziModal({ width: 1000 });
				btn.addEventListener('click', () => {
					$(target).iziModal('open');
					const iframe = document.querySelector(`${target} iframe`);
					if (iframe) iframe.src = iframe.dataset.src;
				});
				$(document).on('closing', target, () => {
					const iframe = document.querySelector(`${target} iframe`);
					if (iframe) iframe.src = '';
				});
			});
		}

		$body.on('loaderEnd', () => console.log('ended'));
	}
}

